import React, { useContext } from 'react';

import { Select } from '@imgly/imgly-website-components';
import { useLocation } from '@reach/router';
import classNames from 'classnames';
import { navigate } from 'gatsby';

import { PageContext } from '../../context/PageContext';
import { getInternalPath } from '../../utils';
import { Links } from '../../utils/constants';

import * as classes from './style.module.scss';

interface Props {
  short?: boolean;
  className?: string;
}

export const DocsMenu: React.FC<Props> = ({ short, className }) => {
  const { pathname } = useLocation();
  const { name: pageName, product } = useContext(PageContext);

  const handleChange = (id: string) => {
    const entry = Links.DocsMenuItems.find(({ id: entryId }) => entryId === id);

    if (entry) {
      navigate(getInternalPath(entry.url, pathname, pageName));
    }
  };

  const options = Links.DocsMenuItems.map(({ name, id }) => ({
    value: id,
    label: name,
  }));

  return (
    <Select
      className={classNames(className, classes.root, {
        [classes.short]: short,
      })}
      selectClassName={classes.select}
      aria-label="Switch the displayed SDK"
      onChange={handleChange}
      label={
        Links.DocsMenuItems.find(({ id }) => id === product)?.shortName ||
        product
      }
      value={product || ''}
      options={options}
    />
  );
};
